module.exports = __webpack_public_path__ + "static/assets/62bf6bfa8f606e548903e05a9c00c930.png";